export default __webpack_public_path__ + "static/media/amaze-7.8310836b.jpg";